import React from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertTriangle, CheckCircle2 } from 'lucide-react';
export function Urgency() {
  return <section className="py-20 bg-white" data-id="element-301">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-302">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-red-50 border-2 border-wc-red rounded-3xl p-8 md:p-12 shadow-lg relative overflow-hidden" data-id="element-303">
          <div className="absolute -right-10 -top-10 text-red-100 opacity-50" data-id="element-304">
            <Clock size={200} data-id="element-305" />
          </div>

          <div className="relative z-10" data-id="element-306">
            <div className="flex items-center gap-3 mb-6 text-wc-red" data-id="element-307">
              <AlertTriangle className="w-8 h-8" data-id="element-308" />
              <h2 className="text-3xl md:text-4xl font-display" data-id="element-309">
                URGENCIA — POR QUÉ ACTUAR HOY
              </h2>
            </div>

            <p className="text-xl font-bold text-gray-900 mb-6 bg-white inline-block px-4 py-2 rounded-lg border border-red-200" data-id="element-310">
              ⚠️ Esta oferta está disponible por tiempo limitado.
            </p>

            <p className="text-lg text-gray-700 mb-4" data-id="element-311">
              El Mundial 2026 ya se acerca. La emoción de vivirlo con el álbum
              completo es ahora, no después.
            </p>
            <p className="text-lg text-gray-700 mb-8 font-medium" data-id="element-312">
              Cada día que esperás es un día menos de disfrutar la experiencia
              con tu familia.
            </p>

            <div className="bg-white p-6 rounded-2xl border border-red-100 shadow-sm" data-id="element-313">
              <p className="font-bold text-gray-900 mb-4" data-id="element-314">
                Las personas que compran hoy tienen la ventaja de:
              </p>
              <ul className="space-y-3" data-id="element-315">
                <li className="flex items-center gap-3" data-id="element-316">
                  <CheckCircle2 className="w-6 h-6 text-wc-red flex-shrink-0" data-id="element-317" />
                  <span className="text-gray-700" data-id="element-318">
                    Empezar a imprimir antes que nadie
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-319">
                  <CheckCircle2 className="w-6 h-6 text-wc-red flex-shrink-0" data-id="element-320" />
                  <span className="text-gray-700" data-id="element-321">
                    Disfrutar el proceso completo del Mundial
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-322">
                  <CheckCircle2 className="w-6 h-6 text-wc-red flex-shrink-0" data-id="element-323" />
                  <span className="text-gray-700" data-id="element-324">
                    Tener el álbum listo cuando arranquen los partidos
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}